import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/useFleetServicePostHook";

const CreateVehicleTypeComponent = loadable(
  () => import("../../../components/Settings/VehicleType/CreateVehicleType")
);
const CreateVehicleType = () => {
  const { mutateAsync , isPostLoading } = usePostHook({
    queryKey: ["vehicle-type"],
    navigateURL: "/vehicle-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_TYPE}`;
    let formData = {
      ...values
     };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Vehicle Type</span>
      </div>
      <CreateVehicleTypeComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate} 
       />
    </>
  );
};

export default CreateVehicleType;
